import React from 'react';

interface MonitorUploadIconProps {
  className?: string;
}

const MonitorUploadIcon: React.FC<MonitorUploadIconProps> = ({ className = '' }) => (
  <svg 
    width='32' 
    height='32'
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={className}
  >
    {/* Monitor screen with rounded corners */}
    <rect 
      x="2" 
      y="3" 
      width="20" 
      height="14" 
      rx="2" 
      stroke="#515151" 
      strokeWidth="1.5" 
      fill="none"
    />
    
    {/* Monitor stand - left leg */}
    <path 
      d="M8 21 L8 17 L10 17" 
      stroke="#515151" 
      strokeWidth="1.5" 
      strokeLinecap="round"
    />
    
    {/* Monitor stand - right leg */}
    <path 
      d="M16 21 L16 17 L14 17" 
      stroke="#515151" 
      strokeWidth="1.5" 
      strokeLinecap="round"
    />
    
    {/* Monitor base */}
    <path 
      d="M6 21 L18 21" 
      stroke="#515151" 
      strokeWidth="1.5" 
      strokeLinecap="round"
    />
    
    {/* Upload arrow - vertical line */}
    <path 
      d="M12 14 L12 7" 
      stroke="#515151" 
      strokeWidth="1.5" 
      strokeLinecap="round"
    />
    
    {/* Upload arrow - left side */}
    <path 
      d="M9 10 L12 7" 
      stroke="#515151" 
      strokeWidth="1.5" 
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    
    {/* Upload arrow - right side */}
    <path 
      d="M15 10 L12 7" 
      stroke="#515151" 
      strokeWidth="1.5" 
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MonitorUploadIcon;
